module.exports = __webpack_public_path__ + "img/2018.78594527.jpg";